import React from 'react';
import {
  Datagrid,
  Pagination,
  ReferenceField,
  ReferenceManyField,
  SimpleShowLayout,
  TextField,
  TextInput,
  required,
  useRecordContext,
} from 'react-admin';
import LinkField from 'components/LinkField';
import LocationInput from 'components/LocationInput';
import QuickCreateButton from 'components/QuickCreateButton';
import useCheckAccess from 'hooks/useCheckAccess';

const HrisLocationMappingsTab = () => {
  const checkAccess = useCheckAccess();
  const record = useRecordContext();
  const company_id = record.id;

  return (
    <SimpleShowLayout>
      {checkAccess('create', 'HrisLocationMapping', [
        'company_id',
        'location_id',
        'external_id',
      ]) && (
        <QuickCreateButton
          resource="HrisLocationMapping"
          title="Create HRIS Location Mapping"
          subheader={`Company: ${record.name}`}
          initialValues={{ company_id }}
        >
          <LocationInput filter={{ company_id }} validate={[required()]} />
          <TextInput label="External ID" source="external_id" validate={[required()]} />
        </QuickCreateButton>
      )}
      <ReferenceManyField
        pagination={<Pagination />}
        label=""
        reference="HrisLocationMapping"
        target="company_id"
      >
        <Datagrid bulkActionButtons={false} rowClick="show">
          <LinkField label="ID" source="id" />
          <TextField label="External ID" source="external_id" sortable={false} />
          <ReferenceField
            label="Location"
            source="location_id"
            reference="Location"
            link="show"
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
        </Datagrid>
      </ReferenceManyField>
    </SimpleShowLayout>
  );
};

export default React.memo(HrisLocationMappingsTab);
